/**
 * Toggles `.navbar--scrolled` class on
 * window scroll event.
 */
const toggleNavbarClassOnScroll = () => {
    const navbar = document.getElementById('main-nav');
    const scrolledClass = 'navbar--scrolled';

    window.onscroll = (e) => {
        const hasClass = navbar.classList.contains(scrolledClass);
        if ( window.scrollY > 0 ) {
            if ( ! hasClass ) {
                navbar.classList.add(scrolledClass);
            }
        } else if ( hasClass ) {
            navbar.classList.remove(scrolledClass);
        }
    };
};

const multiLevelDropdown = () => {

    $('.navbar-toggler').on('click', function(event) {
        $('body').toggleClass('noscroll');
    }) 
    
    // Manually open and close dropodwn instead of using dropdown toggle to allow for inside clicks
    $('li.dropdown .dropdown-toggle').on('click', function (event) {
        if (window.innerWidth > 992) {
            if (!$(this).parent().parent().hasClass('submenu')) {
                $('.submenu.show').removeClass('show');
    
            } else {
                $(this).parent().parent().find('.submenu.show').removeClass('show');
            }
        }
        
        // $('.dropdown-item.open').removeClass('open');
        $(this).parent().toggleClass('show');
        $(this).next().toggleClass('show');
        $(this).toggleClass('open');
    });

    $(document).on('click', function(event) {
        if ($(event.target).closest('dropdown').length != 0) return false;
        if ($(event.target).hasClass('dropdown-toggle')) return false;
        if ($(event.target).closest('.plus').length != 0) return false;
        $('li.dropdown .dropdown-menu.show').removeClass('show');
    })
}

const handleNavbarDrawerToggle = () => {};

module.exports = {
    toggleNavbarClassOnScroll,
    handleNavbarDrawerToggle,
    multiLevelDropdown
};